module.exports = __webpack_public_path__ + "media/images/top/top_user_img_01-497b141167fe705feb7857af5a05c1ac.png";